/** @format */
//import { status, statusFin } from '@/config/modules/libs';
import modelOptions from './modelOptions';
import dataUtils from './dataUtils';

export default {
  mixins: [modelOptions, dataUtils],
  created() {},
  destroyed() {},
  computed: {
    statusItems() {
      let statusFin = this.getFromConfig('config.statuses.object_fin') || [];
      let status = this.getFromConfig('config.statuses.object') || [];
      let items = [];
      let res = [];
      if (this.statusCurrent?.['next']) {
        let arr = this.statusCurrent['next'];
        res = status.filter((s) => {
          return arr.includes(s.value);
        });
      }
      items = JSON.parse(JSON.stringify(res));
      let fin = this.data.status_fin || 0;

      let idx = statusFin.findIndex((el) => {
        return el.value == fin;
      });
      if (idx != -1) {
        res = statusFin.filter((s) => {
          return statusFin[idx]['next'].includes(s.value);
        });
        if (res) items = items.concat(JSON.parse(JSON.stringify(res)));
      }

      return items;
    },

    statusCurrent() {
      let status = this.getFromConfig('config.statuses.object') || [];
      let idx = status.findIndex((el) => {
        return el.value == this.data.status;
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(status[idx]));
    },
  },
  methods: {
    getStatus(type) {
      let idx = this.statuses.findIndex((el) => {
        if (el.formula) {
          let func = eval(el.formula);
          return func(this.data[type]);
        }
        return el.value == this.data[type] && el.field == type;
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    async clickStatus(status) {
      let ok = false; 
      const result = await this.beforeChangeStatus(status);
      console.log('result', result);
      if (!result) return;
      if (status.rules) {
        let rules = status.rules;
        console.log('rules', rules);
        if (rules?.formula) {
          let rule = eval(status.rules.formula);
          if (rule && !rule(this.data)) {
            this.$root.$emit('show-info', {
              text: status?.rules?.text || 'Нет прав для переключения в этот статус',
              type: 'error',
            });
            return;
          }
        }

        if (rules.func) {
          let res = false;
          try {
            res = await this[rules.func]();
          } catch (error) {}
          if (res !== 'ok') {
            this.$root.$emit('show-info', {
              text: status?.rules?.text || res || 'Нет прав для переключения в этот статус',
              type: 'error',
            });
            return;
          }
        }
      }
      ok = await this.$root.$confirm({
        title: 'Изменение статуса',
        message: [`Вы действительно хотите поменять `, ` статус на [${status.text}]?`],
        okButton: 'Да',
        cancelButton: 'Нет',
      });
      if (!ok) return;
      if (status.func) {
        this[status.func](status.value);
      } else {
        this.changeStatus(status);
      }
      this.fitchData();
    },
    async beforeChangeStatus(status) {
      return true;
    },
    async changeStatus(status) {
      let url = this?.apiStatus || this.url;
      if (!url || !this.data.id) {
        console.log('no data', { url: this.url, id: this.data.id });
        return;
      }
      if (status?.rules?.formula) {
        let rule = eval(status.rules.formula);
        if (rule && !rule(this.data)) {
          this.$root.$emit('show-info', {
            text: status?.rules?.text || 'Нет прав для переключения в этот статус',
            type: 'error',
          });
          return;
        }
      }
      this.loading = true;
      let val = status?.setValue !== undefined ? status.setValue : status.value;
      let data = { id: this.data.id, [status.field]: val };
      if (status?.status_history_comment) data['status_history_comment'] = status.status_history_comment;
      if (status?.trigger?.fields) {
        data = Object.assign({}, data, status.trigger.fields);
      }
      if (status?.trigger?.setData && typeof status.trigger.setData === 'object') {
        for (const key in status.trigger.setData) {
          this.setDataDeep(data, key, status.trigger.setData[key]);
          // data._setData(key, status.trigger.setData[key]);
        }
        data = Object.assign({}, data, status.trigger.fields);
      }
      let response = await this.$axios.post(url, data);
      this.loading = false;
      status = response.data.status == 'ok';
      if (response.data.data) {
        Object.assign(this.data, response.data.data);
        this.$root.$emit('show-info', {
          text: 'Статус изменен',
        });
      }
    },
    status10(s) {
      this.changeStatus(s);
      this.$router.push({ name: 'objects_view', params: { id: this.id } });
    },
    statusSale(s) {
      this.showStateSaleDialog = true;
    },
  },
};
